export function now() {
  return new Date();
}
